import React from "react";
import { Controller } from "react-hook-form";
import FIlterSelect from "../../filter-select";
import Input from "../../input";




interface Details {
    control: any;
    clearErrors: any;
    errors: any;
    discount: any;
}
const Eligibility: React.FC<Details> = ({ control, discount }) => {
    return ( 
        <div className="flex flex-col gap-5">
            <div className="items-center gap-4">
                <Controller
                    name="eligibleItems"
                    defaultValue={discount?.eligibleItems}
                    control={control}
                    render={({ field }) => (
                    <FIlterSelect
                        name="eligibleItems"
                        options={[
                        { value: "all", label: "All" }
                        ]}
                        className="w-full"
                        label="Eligible Items"
                        onChange={(selectedValue) => {
                        field.onChange(selectedValue);
                        }}
                        value={field.value}
                    />
                    )}
                />
            </div>
            <div className="items-center gap-4">
                <Controller
                    name="eligibleCustomers"
                    defaultValue={discount?.eligibleCustomers}
                    control={control}
                    render={({ field }) => (
                    <FIlterSelect
                        name="eligibleCustomers"
                        options={[
                        { value: "all", label: "All" },
                        { value: "b2b", label: "B2B" },
                        { value: "b2c", label: "B2C" },
                        ]}
                        className="w-full"
                        label="Eligible Customers"
                        onChange={(selectedValue) => {
                        field.onChange(selectedValue);
                        }}
                        value={field.value}
                    />
                    )}
                />
            </div>

            <div className="items-center gap-4">
                <Controller
                name="minimumPurchaseRequirement"
                defaultValue={discount?.minimumPurchaseRequirement}
                control={control}
                rules={{
                    required: "Minimum Purchase Requirement is required",
                }}
                render={({ field, fieldState }) => (
                    <Input
                    value={field.value}
                    className="w-full"
                    label="Minimum Purchase Requirement"
                    placeholder="Enter Minimum Purchase Requirement"
                    error={fieldState?.error?.message}
                    onChange={field.onChange}
                    />
                )}
                />
            </div>
            <div className="items-center gap-4">
                <Controller
                name="usageLimit"
                defaultValue={discount?.usageLimit}
                control={control}
                rules={{
                    required: "Usage limit is required",
                }}
                render={({ field, fieldState }) => (
                    <Input
                    value={field.value}
                    className="w-full"
                    label="Usage Limit"
                    placeholder="Enter the usage limits for customers"
                    error={fieldState?.error?.message}
                    onChange={field.onChange}
                    />
                )}
                />
            </div>
            <div className="items-center gap-4">
                <Controller
                name="termsAndConditions"
                defaultValue={discount?.termsAndConditions}
                control={control}
                rules={{
                    required: "Terms and condition is required",
                }}
                render={({ field, fieldState }) => (
                    <Input
                    value={field.value}
                    className="w-full"
                    label="Terms and Conditions"
                    placeholder="Enter terms and condition"
                    error={fieldState?.error?.message}
                    onChange={field.onChange}
                    />
                )}
                />
            </div>
        </div>
     );
}
 
export default Eligibility;